import styled from 'styled-components';
import { Typography, Box, Paper, Button, Tab, Card, Grid, TextField, Accordion, AccordionSummary, AccordionDetails, Chip, IconButton } from '@mui/material';

export const FormGrid = styled(Grid)`
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 30px;

  .active {
    opacity: 1 !important;
  }

  .stepActive {
    border-color: rgb(251, 132, 4);
  }

  .briefingTitle {
    font-size: 28px;
    font-weight: 600;
  }

  .briefingDescription {
    font-size: 20px;
    opacity: 0.75;
  }
`

export const Input = styled(TextField)`
  background-color: transparent;
  /* border: 0.4px solid rgba(255, 255, 255, 0.50) !important; */
  border-radius: 10px;
  width: 100%;
  min-height: 40px;
`

export const InputContainer = styled(Grid)`
  .readOnly {
      .MuiOutlinedInput-notchedOutline {
      height: 45px;
      border-radius: 10px;
      border: 0.4px solid;
      border-color: transparent !important;
    }
  }
  .urlPointer {
    input {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`

export const InputGrid = styled(Grid)`
  gap: 20px;
  .MuiOutlinedInput-input {
    color: #FFFFFF;
  }
  .MuiInputBase-root.Mui-focused {
    box-shadow: 0px 0px 10px #FC6508;
    svg {
      color: #E22B00;
    }
    .MuiOutlinedInput-input {
      color: #E22B00;
    }
  }
  .MuiAutocomplete-endAdornment {
    top: 5px !important;
    transform: none !important;
  }
  .MuiAutocomplete-root .MuiAutocomplete-input {
    padding-top: 0 !important;
  }
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    padding-top: 5px !important;
  }
  .MuiAutocomplete-popper {
    background-color: #0E0E0E;
    border: 1px solid;
  }
  .MuiFormHelperText-root{
    margin-top: 5px;
  }
  & .MuiOutlinedInput-root.Mui-focused{
    & > fieldset {
      border-color: transparent;
    }
  }
  .MuiPaper-root-MuiAutocomplete-paper {
    border-radius: 5px !important;
  }
  .MuiPaper-root{
    border-radius: 5px !important;
  }
  svg {
    color: white;
    transform: rotateY(180deg);
  }
`

export const CommunityInfoCard = styled(Card)`
  background: linear-gradient(127.09deg, rgba(0, 0, 0, 0.6) 19.41%, rgba(0, 0, 0, 0.6) 76.65%) !important;
  && {
    overflow: auto;
    max-height: 80vh;
  }
`

export const CalendarContainer = styled(Card)`
  background: linear-gradient(127.09deg, rgba(0, 0, 0, 0.6) 19.41%, rgba(0, 0, 0, 0.6) 76.65%) !important;
  && {
    overflow: auto;
    max-height: 80vh;
  }
`

export const FormTitleGrid = styled(Grid)`
  font-size: 18px;
  font-weight: 400;

  .subTitle {
    font-size: 16px;
    opacity: 0.75;
  }
`

export const EditButton = styled(Button)`
  && {
    gap: 10px;
    width: 180px;
    height: 40px;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    background: linear-gradient(180deg, #FB8404 0%, #FE1E14 100%);
    padding: 6px 6px;

    &:hover{
      transform: scale(1.1);
      color: #fff;
    }
  }
`

export const CalendarTitle = styled(Typography)({
  fontSize: '28px !important',
  fontWeight: 'bold !important',
  marginBottom: '8px !important',
});

export const CalendarDescription = styled(Typography)({
  color: 'rgba(255,255,255,0.7) !important',
  marginBottom: '24px !important',
});

export const TabButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active ? '#FC6508 !important' : 'rgba(255, 255, 255, 0.05) !important',
  color: 'white !important',
  borderRadius: '20px !important',
  padding: '10px 20px !important',
  margin: '0 8px 0 0 !important',
  fontSize: '14px !important',
  fontWeight: '500 !important',
  border: active ? 'none !important' : '1px solid rgba(255, 255, 255, 0.1) !important',
  textTransform: 'none !important',
  minWidth: 'auto !important',
  transition: 'all 0.3s ease !important',
  backdropFilter: 'blur(10px) !important',
  '&:hover': {
    backgroundColor: active ? '#e45400 !important' : 'rgba(252, 101, 8, 0.1) !important',
    borderColor: active ? 'none !important' : 'rgba(252, 101, 8, 0.3) !important',
    transform: 'translateY(-1px) !important',
  },
}));

export const WeekCard = styled(Paper)({
  backgroundColor: '#1A1A1F !important',
  color: 'white !important',
  padding: '16px !important',
  height: '100% !important',
  borderRadius: '8px !important',
});

export const WeekTitle = styled(Typography)({
  fontSize: '18px !important',
  fontWeight: 'bold !important',
  marginBottom: '16px !important',
});

export const ContentItem = styled(Box)({
  marginBottom: '16px !important',
});

export const ContentTitle = styled(Typography)({
  color: '#FC6508 !important',
  fontWeight: 'bold !important',
  fontSize: '14px !important',
});

export const ContentDescription = styled(Typography)({
  fontSize: '14px !important',
});

export const ContentHighlight = styled(Typography)({
  color: '#FC6508 !important',
  fontWeight: 'bold !important',
  fontSize: '14px !important',
  marginTop: '16px !important',
});

export const EngagementSignal = styled(Typography)({
  color: '#FC6508 !important',
  fontWeight: 'bold !important',
  fontSize: '14px !important',
  marginTop: '16px !important',
});

export const TemplateButton = styled(Button)({
  backgroundColor: '#FC6508 !important',
  color: 'white !important',
  borderRadius: '5px !important',
  padding: '8px !important',
  marginTop: '16px !important',
  width: '100% !important',
  '&:hover': {
    backgroundColor: '#e45400 !important',
  },
});

export const TemplateSection = styled(Box)({
  marginTop: '32px !important',
  padding: '20px !important',
  borderRadius: '12px !important',
  backgroundColor: 'rgba(255, 255, 255, 0.05) !important',
  border: '1px solid rgba(255, 255, 255, 0.1) !important',
});

export const TemplateSectionTitle = styled(Typography)({
  fontSize: '18px !important',
  fontWeight: '600 !important',
  color: '#FC6508 !important',
  marginBottom: '16px !important',
  display: 'flex !important',
  alignItems: 'center !important',
  gap: '8px !important',
});

export const TemplateListItem = styled(Box)({
  display: 'flex !important',
  alignItems: 'flex-start !important',
  marginBottom: '12px !important',
  paddingLeft: '0px !important',
});

export const TemplateListItemBullet = styled(Box)({
  width: '6px !important',
  height: '6px !important',
  borderRadius: '50% !important',
  backgroundColor: '#FC6508 !important',
  marginRight: '16px !important',
  marginTop: '10px !important',
  flexShrink: 0,
});

export const TemplateListItemText = styled(Typography)`
  color: white !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
  font-weight: 400 !important;

  &.quickIdeas {
    color: #8F8F8F !important;
  }
`

// Estilos para ScriptGenerator
export const FormatCard = styled(Box)(({ theme, selected }) => ({
  padding: '16px',
  backgroundColor: selected ? 'rgba(252, 101, 8, 0.1)' : '#1A1A1F',
  border: selected ? '1px solid #FC6508' : '1px solid transparent',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: selected ? 'rgba(252, 101, 8, 0.15)' : '#25252c',
  }
}));

export const FormatIcon = styled(Box)(({ theme }) => ({
  fontSize: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#2a2a33',
}));

export const ObjectiveCard = styled(Box)(({ theme, selected }) => ({
  padding: '16px',
  backgroundColor: selected ? 'rgba(252, 101, 8, 0.1)' : '#1A1A1F',
  border: selected ? '1px solid #FC6508' : '1px solid transparent',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minHeight: '70px',
  '&:hover': {
    backgroundColor: selected ? 'rgba(252, 101, 8, 0.15)' : '#25252c',
  }
}));

// Adicione no arquivo style.js, após os estilos existentes

export const ScriptTag = styled(Box)(({ theme }) => ({
  padding: '4px 8px',
  backgroundColor: 'rgba(252, 101, 8, 0.2)',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 'bold',
  color: '#FC6508',
  display: 'inline-block'
}));

export const ScriptDetailChip = styled(Box)(({ theme }) => ({
  padding: '6px 12px',
  backgroundColor: '#252529',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold',
  color: 'white',
  display: 'inline-block'
}));

export const ListFilterTab = styled(Tab)`
  font-size: 14px !important;
  && {
    padding: 5px 10px !important;
  }
`

// Accordion components for calendar layout
export const AccordionCard = styled(Card)`
  background: linear-gradient(127.09deg, rgba(0, 0, 0, 0.6) 19.41%, rgba(0, 0, 0, 0.6) 76.65%) !important;
  gap: 20px;

  && {
    padding: 40px 30px;
  }
`;

export const CheckboxAccordion = styled(Accordion)`
  .positive {
    color: #65EFAD;
  }
  .negative {
    color: #D7007B;
  }
    
  && {
    width: 100%;
    border: 1px solid #FFFFFF73;
    padding: 0 20px;
    border-radius: 5px;
  }
`

export const CheckboxAccordionSummary = styled(AccordionSummary)`
  && {
    padding: 0;
    font-size: 18px;
    svg {
      color: #fff;
    }
  }
`

export const CheckboxAccordionDetails = styled(AccordionDetails)`
  margin-bottom: 20px;

  .subTitle {
    font-size: 16px;
  }

  .content {
    font-size: 18px;
    font-weight: 700;
    text-align: justify;
  }

  .attachment {
    text-decoration: underline !important;
    color: #fff !important;
    width: fit-content;
  }

  && {
    padding: 0;
    gap: 5px;
    display: flex;
    flex-direction: column;
  }
`

// CommunityInfo styles
export const CommunityInfoContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
`;

export const CommunityInfoTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 400;

  .subTitle {
    font-size: 16px;
    opacity: 0.75;
  }
`;

export const CommunityInfoEditButton = styled(Button)`
  && {
    width: 41px;
    min-width: 30px;
    height: 41px;
    border-radius: 5px;
    background: linear-gradient(180deg, #FB8404 0%, #FE1E14 100%);
    padding: 6px 6px;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const CommunityInfoFormGrid = styled(Grid)`
  font-size: 16px;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 30px;
  gap: 30px;
`;

export const CommunityInfoInput = styled(TextField)`
  background-color: transparent;
  border-radius: 10px;
  width: 100%;
  min-height: 40px;

  .MuiOutlinedInput-root {
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: transparent;
      }
    }
  }
`;

export const CommunityInfoInputContainer = styled(Grid)`
  .readOnly {
    .MuiOutlinedInput-notchedOutline {
      height: 45px;
      border-radius: 10px;
      border: 0.4px solid;
      border-color: transparent !important;
    }
  }
`;

export const CommunityInfoInputGrid = styled(Grid)`
  gap: 20px;

  .MuiOutlinedInput-input {
    color: #FFFFFF;
  }

  .MuiInputBase-root.Mui-focused {
    box-shadow: 0px 0px 10px #FC6508;
    svg {
      color: #E22B00;
    }
    .MuiOutlinedInput-input {
      color: #E22B00;
    }
  }
`;

export const CommunityInfoChip = styled(Chip)`
  && {
    background-color: #FC6508;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: bold;
    border-radius: 16px;

    &:hover {
      background-color: #e45400;
    }
  }
`;

export const CommunityInfoDeleteButton = styled(Button)`
  && {
    background-color: #E91E63;
    color: #FFFFFF;
    border-radius: 5px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: bold;

    &:hover {
      background-color: #C2185B;
    }
  }
`;

export const CommunityInfoModalTitle = styled(Typography)`
  && {
    font-size: 24px;
    font-weight: bold;
    color: #FC6508;
  }
`;

export const CommunityInfoModalText = styled(Typography)`
  && {
    font-size: 18px;
  }
`;

export const ScriptLibraryEmptyContainer = styled(Box)({
  marginTop: '112px !important',
  display: 'flex !important',
  flexDirection: 'column !important',
  alignItems: 'center !important'
});

export const ScriptLibraryEmptyImage = styled('img')({
  width: '170px !important',
  height: 'auto !important',
  marginBottom: '20px !important'
});

export const ScriptLibraryEmptyTitle = styled(Typography)({
  color: '#fff !important',
  marginBottom: '16px !important',
  fontSize: '24px !important'
});

export const ScriptLibraryCreateButton = styled(Button)(({ disabled }) => ({
  backgroundColor: disabled ? '#666 !important' : '#FC6508 !important',
  color: '#fff !important',
  padding: '12px 24px !important',
  borderRadius: '5px !important',
  fontSize: '14px !important',
  width: '300px !important',
  '&:hover': {
    backgroundColor: disabled ? '#666 !important' : '#e45400 !important',
  },
  '&:disabled': {
    backgroundColor: '#666 !important',
    color: '#999 !important'
  }
}));

export const ScriptLibraryHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '32px'
});

export const ScriptLibrarySection = styled(Box)({
  marginBottom: '32px'
});

export const ScriptLibrarySectionTitle = styled(Typography)({
  color: '#fff !important',
  fontWeight: 'bold !important',
  marginBottom: '16px !important'
});

export const ScriptLibraryCard = styled(Box)(({ completed }) => ({
  backgroundColor: completed ? '#2A4A3A' : '#101010',
  borderRadius: '5px',
  padding: '16px',
  cursor: 'pointer',
  transition: 'all 0.2s',
  position: 'relative',
  '&:hover': {
    backgroundColor: completed ? '#2f5040' : '#101010',
    transform: 'translateY(-2px)',
    boxShadow: completed ? 'none' : '0 4px 15px rgba(252, 101, 8, 0.3)'
  }
}));

export const ScriptLibraryCardTitle = styled(Typography)(({ completed }) => ({
  color: completed ? '#65EFAD !important' : '#FB7E04 !important',
  fontWeight: 'bold !important',
  fontSize: '14px !important',
  marginBottom: '8px !important',
  paddingRight: completed ? '32px !important' : '0 !important'
}));

export const ScriptLibraryCardDate = styled(Typography)(({ completed }) => ({
  color: completed ? '#B2B2B2 !important' : '#B2B2B2 !important',
  fontWeight: completed ? '600 !important' : '400 !important',
  fontSize: '12px !important',
  marginBottom: completed ? '8px !important' : '16px !important'
}));

export const ScriptLibraryCompletedBadge = styled(Box)({
  position: 'absolute !important',
  top: '16px !important',
  right: '16px !important',
  backgroundColor: '#65EFAD !important',
  borderRadius: '50% !important',
  width: '24px !important',
  height: '24px !important',
  display: 'flex !important',
  alignItems: 'center !important',
  justifyContent: 'center !important'
});

export const ScriptLibraryCompletedCheck = styled(Typography)({
  color: '#000 !important',
  fontSize: '12px !important',
  fontWeight: 'bold !important'
});

export const ScriptLibraryShowMoreButton = styled(Typography)({
  color: '#FC6508 !important',
  cursor: 'pointer !important',
  fontWeight: 'bold !important',
  fontSize: '14px !important'
});

export const ScriptLibraryViewModal = styled(Box)({
  backgroundColor: '#101010',
  borderRadius: '25px',
  padding: 0,
  width: '90%',
  maxWidth: '700px',
  maxHeight: '90vh',
  overflowY: 'auto',
  position: 'relative',
  border: '1px solid rgba(255, 255, 255, 0.45)',
  color: '#fff'
});

export const ScriptLibraryViewModalCloseButton = styled(IconButton)`
  position: absolute !important;
  right: 8px !important;
  top: 8px !important;
  color: #F2F2F2 !important;
`;

export const ScriptLibraryViewModalHeader = styled(Box)`
  display: flex !important;
  padding: 16px !important;
  padding-left: 24px !important;
  flex-direction: column !important;
`;

export const ScriptLibraryViewModalTitle = styled(Typography)`
  color: #fff !important;
  font-weight: bold !important;
  margin-bottom: 4px !important;
  padding-right: 32px !important;
`;

export const ScriptLibraryViewModalDate = styled(Typography)`
  color: rgba(255,255,255,0.6) !important;
  font-size: 14px !important;
`;

export const ScriptLibraryViewModalContent = styled(Box)`
  padding: 24px !important;
`;

export const ScriptLibraryViewModalText = styled(Typography)`
  color: #fff !important;
  white-space: pre-line !important;
  line-height: 1.6 !important;
  font-size: 14px !important;
`;

export const ScriptLibraryViewModalActions = styled(Box)`
  display: flex !important;
  justify-content: flex-end !important;
  margin-top: 24px !important;
  margin-right: 24px !important;
  margin-bottom: 24px !important;
`;

export const ScriptLibraryViewModalActionsContainer = styled(Box)`
  display: flex !important;
  gap: 16px !important;
`;

export const ScriptLibraryDeleteButton = styled(Button)`
  flex: 1 !important;
  background: linear-gradient(180deg, #D04494 0%, #D7004D 100%);
  border-color: #D04494 !important;
  color: #fff !important;
  padding: 12px !important;
  border-radius: 5px !important;
  &:hover {
    border-color: #D7004D !important;
    background: linear-gradient(180deg, #D7004D 0%, #D04494 100%);
  }
`;

export const ScriptLibraryCopyButton = styled(Button)`
  flex: 1;
  background-color: #FC6508 !important;
  color: #fff !important;
  font-weight: bold;
  padding: 12px 24px;
  border-radius: 5px !important;
  width: 150px;
  &:hover {
    background-color: #e45400 !important;
  }
`;

export const ScriptLibraryConfirmModal = styled(Box)`
  background-color: #101010;
  border-radius: 25px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.45);
  color: #fff;
`;

export const ScriptLibraryConfirmModalCloseButton = styled(IconButton)`
  position: absolute !important;
  right: 8px !important;
  top: 8px !important;
  color: #F2F2F2 !important;
`;

export const ScriptLibraryConfirmModalContent = styled(Grid)`
  padding: 24px;
`;

export const ScriptLibraryConfirmModalTitle = styled('p')`
  font-size: 24px;
`;

export const ScriptLibraryConfirmModalText = styled('p')`
  font-size: 18px;
`;

export const ScriptLibraryConfirmModalActions = styled(Grid)`
  padding: 24px;
  padding-top: 0;
`;

export const ScriptLibraryTagChip = styled(Chip)(({ completed }) => `
  background-color: ${completed ? 'rgba(101, 239, 173, 0.2) !important' : 'rgba(252, 101, 8, 0.2) !important'} ;
  color: ${completed ? '#65EFAD !important' : '#FC6508 !important'} ;
  font-weight: bold !important;
  font-size: 12px !important;
  height: 24px !important;
  border-radius: 2px !important;
  & .MuiChip-label {
    padding: 16px 8px !important;
  }
`);